module.exports = __webpack_public_path__ + "img/1d158bd47d4fe9159a5b0f6671ec2ed7.png";